import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { KEEN_KEY, KEEN_TABLE_INTERVAL } from '@keen.io/parser';
import { COLUMN_JOIN, VALUE } from '../../constants';
export var categoricalChronologicalTransformation = function (data, keys, formatValue, dataSeriesGroups) {
    var columns = [
        KEEN_TABLE_INTERVAL,
        dataSeriesGroups.join(COLUMN_JOIN),
        VALUE,
    ];
    var rows = [];
    data.forEach(function (item) {
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return [
            item[KEEN_KEY],
            keyName,
            valueFormatter(item[keyName], formatValue),
        ]; })));
    });
    return __spread([columns], rows);
};
